import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { IMAGES } from "@/lib/images";
import { scrollToId } from "./Reveal";

const LINKS = [
  { label: "The Program", id: "curriculum" },
  { label: "Instructor", id: "instructor" },
  { label: "Enroll", id: "pricing" },
  { label: "Story", id: "story" },
  { label: "FAQ", id: "faq" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <motion.header
      data-testid="navbar"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,backdrop-filter,padding] duration-500 ${
        scrolled ? "bg-wine-deep/85 backdrop-blur-xl py-3 border-b border-gold/15" : "py-5"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 flex items-center justify-between">
        <button data-testid="nav-logo" onClick={() => go("hero")} className="flex items-center gap-3">
          <img src={IMAGES.logoLight} alt="BNB Academy" className="h-10 w-auto" />
        </button>

        <nav className="hidden lg:flex items-center gap-9">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => go(l.id)}
              className="font-mono text-[11px] uppercase tracking-[0.22em] text-cream/70 hover:text-gold transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <button
          data-testid="nav-cta"
          onClick={() => go("enroll")}
          className="hidden lg:inline-flex items-center rounded-full bg-gold px-6 py-2.5 font-mono text-[11px] uppercase tracking-[0.18em] text-wine-deep hover:bg-cream transition-colors duration-300"
        >
          Join Waitlist
        </button>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden text-cream p-2"
          aria-label="Menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="mobile-menu"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="lg:hidden overflow-hidden bg-wine-deep/95 backdrop-blur-xl border-t border-gold/15"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              {LINKS.map((l) => (
                <button
                  key={l.id}
                  onClick={() => go(l.id)}
                  className="text-left font-mono text-xs uppercase tracking-[0.22em] text-cream/80"
                >
                  {l.label}
                </button>
              ))}
              <button
                onClick={() => go("enroll")}
                className="mt-2 rounded-full bg-gold px-6 py-3 font-mono text-[11px] uppercase tracking-[0.18em] text-wine-deep"
              >
                Join Waitlist
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
